<template>
  <div class="resend-order-details">
    <v-row>
      <v-col cols="12" class="pb-0">
        เนื่องจากมีคำสั่งซื้อจำนวนมาก SMS และ
        อีเมลยืนยันคำสั่งซื้ออาจล่าช้า
        หากไม่ได้รับสามารถกดปุ่มด้านล่างเพื่อรับรายละเอียดยืนคำสั่งซื้ออีกครั้ง
      </v-col>
      <v-col>
        <a
          depressed
          class="btn-link"
          :class="{ 'btn-link--disabled': cooldown.sms > 0 }"
          text
          :color="colorBnn['color-bnn']"
          @click="handleResend('sms')"
        >
          <v-icon
            left
            size="16px"
            :color="
              cooldown.sms > 0 ? '#818181' : colorBnn['color-bnn']
            "
          >
            mdi-cellphone
          </v-icon>
          {{
            cooldown.sms > 0
              ? `ส่ง SMS ได้อีกครั้งใน ${cooldown.sms} วิ`
              : 'ส่ง SMS'
          }}
        </a>
        <a
          depressed
          class="btn-link ml-4"
          :class="{ 'btn-link--disabled': cooldown.email > 0 }"
          text
          :color="colorBnn['color-bnn']"
          @click="handleResend('email')"
        >
          <v-icon
            left
            size="16px"
            :color="
              cooldown.email > 0 ? '#818181' : colorBnn['color-bnn']
            "
          >
            mdi-email-outline
          </v-icon>
          {{
            cooldown.email > 0
              ? `ส่งอีเมลได้อีกครั้งใน ${cooldown.email} วิ`
              : 'ส่งอีเมล'
          }}
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import axios from '@/config/api'
import colorBnn from '@/config/color'
import { useAxiosErrorHandler } from '@/composables/useAxiosErrorHandler'

const CHANNELS = ['sms', 'email']
const COOLDOWN_SECONDS = 60

export default {
  name: 'BaseResendOrderDetails',

  data() {
    return {
      colorBnn,
      isLoading: false,
      cooldown: { sms: 0, email: 0 },
      expiresAt: { sms: null, email: null },
      cooldownInterval: null,
    }
  },

  computed: {
    orderUuid() {
      return this.$route.params.uid ?? this.$route.params.orderId
    },
  },

  mounted() {
    CHANNELS.forEach(type => {
      const stored = localStorage.getItem(
        this.cooldownStorageKey(type),
      )
      if (!stored) return

      const remaining = moment
        .unix(Number(stored))
        .diff(moment(), 'seconds')

      if (remaining > 0) {
        this.expiresAt[type] = Number(stored)
        this.cooldown[type] = remaining
      } else {
        localStorage.removeItem(this.cooldownStorageKey(type))
      }
    })

    this.cooldownInterval = setInterval(() => {
      CHANNELS.forEach(type => {
        if (!this.expiresAt[type]) return

        const remaining = moment
          .unix(this.expiresAt[type])
          .diff(moment(), 'seconds')

        this.cooldown[type] = Math.max(0, remaining)

        if (this.cooldown[type] <= 0) {
          this.expiresAt[type] = null
          localStorage.removeItem(this.cooldownStorageKey(type))
        }
      })
    }, 1000)
  },

  beforeDestroy() {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval)
  },

  methods: {
    cooldownStorageKey(type) {
      return `resendCooldown_${this.orderUuid}_${type}`
    },

    async handleResend(type) {
      if (
        this.isLoading ||
        !this.orderUuid ||
        this.cooldown[type] > 0
      )
        return

      this.isLoading = true

      try {
        await axios.post('/orders/resend-notification', {
          order_uuid: this.orderUuid,
          channel: type,
        })

        this.$toast.success(
          `ส่ง ${type} ยืนยันคำสั่งซื้ออีกครั้งแล้ว กรุณาตรวจสอบ ${type} ของคุณ`,
          {
            duration: 5000,
            position: 'top',
          },
        )

        const expiresAtUnix = moment()
          .add(COOLDOWN_SECONDS, 'seconds')
          .unix()

        this.expiresAt[type] = expiresAtUnix
        this.cooldown[type] = COOLDOWN_SECONDS
        localStorage.setItem(
          this.cooldownStorageKey(type),
          expiresAtUnix,
        )
      } catch (error) {
        useAxiosErrorHandler().handleError(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.resend-order-details
	// background-color: rgba($color-bnn-gray-light, 0.1)
	// padding-inline: 16px
.btn-link {
	font-size: 14px
	font-weight: 600
    color: $color-warning
    cursor: pointer
  }
.btn-link--disabled {
    color: $color-bnn-gray-medium-2
    opacity: 0.6
    pointer-events: none
  }
</style>
